/**
 * Funcionalidades opcionales del POS.
 * El flujo principal es siempre pedidos de retiro.
 * Mesas: preparado para activar en el futuro sin afectar retiro.
 */
export const FEATURE_MESAS = false;
